document.addEventListener('DOMContentLoaded', function () {
	document.body.classList.add('js-enabled');
});

const siteHeader = document.querySelector('.site-header');
const stickyOffset = 105;
let lastScrollTop = 0;
let ticking = false;

function updateHeader(scrollTop) {
	if (!siteHeader) {
		return;
	}

	if (scrollTop > lastScrollTop) {
		siteHeader.classList.add('scrolled');
	} else {
		siteHeader.classList.remove('scrolled');
	}

	if (scrollTop > stickyOffset) {
		siteHeader.classList.add('sticky');
	} else {
		siteHeader.classList.remove('sticky');
	}

	lastScrollTop = scrollTop;
}

function handleScroll() {
	const scrollTop =
		window.pageYOffset || document.documentElement.scrollTop;
	updateHeader(scrollTop);
	ticking = false;
}

function requestTick() {
	if (!ticking) {
		ticking = true;
		window.requestAnimationFrame(handleScroll);
	}
}

window.addEventListener('scroll', requestTick);
